module.exports = __webpack_public_path__ + "img/qianduan.19db1bda.jpg";